import EventGeneratePreview from '@/screens/EventGeneratePreview';

export default function PrivateEventGeneratePreviewRoute() {
  return <EventGeneratePreview />;
}
